module.exports = __webpack_public_path__ + "img/1580711529.640bc37b.jpg";